import { render, staticRenderFns } from "./traveler-label.vue?vue&type=template&id=08c62219&scoped=true"
import script from "./traveler-label.vue?vue&type=script&lang=js"
export * from "./traveler-label.vue?vue&type=script&lang=js"
import style0 from "./traveler-label.vue?vue&type=style&index=0&id=08c62219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c62219",
  null
  
)

export default component.exports